import { createSlice } from '@reduxjs/toolkit';

export const deliveryTimeText = createSlice({
  name: 'deliveryTimeText',
  initialState: {
    data: '',
  },

  reducers: {
    setDeliveryTimeText: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setDeliveryTimeText } = deliveryTimeText.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getDeliveryTimeText = (state) => {
  return state.deliveryTimeText.data;
};

export default deliveryTimeText.reducer;
